import React from "react";
import {
  Table,
  Paper,
  TableRow,
  TableBody,
  TableHead,
  TableCell,
  IconButton,
  TableContainer,
  TablePagination,
} from "@mui/material";
import { esignIcons } from "../../../../../components/Esign/icons";

const tableHeaders = [
  {
    title: "Template ID",
  },
  {
    title: "Subject",
  },
  {
    title: "Template name",
  },
  {
    title: "Actions",
  },
];

const TemplatesList = ({
  rows,
  totalRows,
  page,
  rowsPerPage,
  onPageChange,
  onRowsPerPageChange,
  onEditTemplate,
  onDeleteTemplate,
}) => {
  return (
    <Paper
      sx={{
        width: "100%",
        overflow: "hidden",
        boxShadow: "none",
        height: "90%",
        mt: "15px",
      }}
    >
      <TableContainer sx={{ maxHeight: "95%" }}>
        <Table stickyHeader>
          <TableHead
            sx={{
              background: "red",
              fontSize: "15px",
              fontWeight: 500,
              color: "#1D1D1D",
            }}
          >
            <TableRow>
              <TableCell
                sx={{
                  background: "#F5F5F5",
                  paddingLeft: "30px",
                  width: 120,
                  maxWidth: 130,
                  fontWeight: 500,
                  fontStyle: "Medium",
                  fontSize: "15px",
                  lineHeight: "100%",
                  letterSpacing: "0px",
                  color: "#1D1D1D",
                }}
              >
                S. No.
              </TableCell>
              {tableHeaders.map((item) => (
                <TableCell
                  key={item.title}
                  sx={{
                    background: "#F5F5F5",
                    fontWeight: 500,
                    fontStyle: "Medium",
                    fontSize: "15px",
                    lineHeight: "100%",
                    letterSpacing: "0px",
                    color: "#1D1D1D",
                  }}
                >
                  {item?.title || ""}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.length > 0 ? (
              rows.map((row, index) => (
                <TableRow
                  key={row.id}
                  sx={{ "&:hover": { backgroundColor: "#fafafa" } }}
                >
                  <TableCell
                    sx={{
                      pl: "30px !important",
                      color: "text.secondary",
                      width: 70,
                      maxWidth: 70,
                    }}
                    className="tablecell-styling"
                  >
                    {(page * rowsPerPage + index + 1)
                      .toString()
                      .padStart(2, "0")}
                  </TableCell>
                  <TableCell
                    className="tablecell-styling"
                    sx={{ color: "text.secondary", width: 250 }}
                  >
                    {row.template_id}
                  </TableCell>
                  <TableCell
                    className="tablecell-styling"
                    sx={{ color: "text.secondary", width: 320 }}
                  >
                    {row.template_subject}
                  </TableCell>
                  <TableCell
                    className="tablecell-styling"
                    sx={{ color: "text.secondary", width: 260 }}
                  >
                    {row.template_name}
                  </TableCell>
                  {row.template_id !== "default_template" ? (
                    <TableCell
                      className="tablecell-styling"
                      sx={{
                        width: 150,
                        pl: 4,
                      }}
                    >
                      <IconButton onClick={() => onEditTemplate(row)}>
                        {esignIcons.editIconBlue}
                      </IconButton>
                      <IconButton onClick={() => onDeleteTemplate(row)}>
                        {esignIcons.deleteIconRed}
                      </IconButton>
                    </TableCell>
                  ) : (
                    <TableCell
                      className="tablecell-styling"
                      sx={{
                        width: 150,
                        pl: 4,
                      }}
                    ></TableCell>
                  )}
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No email template found!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 50]}
        sx={{ "& .MuiTablePagination-toolbar": { paddingRight: "20px" } }}
        component="div"
        page={page}
        count={totalRows}
        rowsPerPage={rowsPerPage}
        onPageChange={onPageChange}
        onRowsPerPageChange={onRowsPerPageChange}
        sx={{
          position: "sticky",
          bottom: 0,
          backgroundColor: "white",
          zIndex: 2,
        }}
      />
    </Paper>
  );
};

export default TemplatesList;
